import { PolicyTemplate } from '../../../../types/policies';
import { useUpdatePolicyTemplate, UseUpdatePolicyTemplateParams } from './useUpdatePolicyTemplate';
import { useCallback } from 'react';

export type UseUpdatePolicyTemplateFavoriteParams = UseUpdatePolicyTemplateParams;

export const useUpdatePolicyTemplateFavorite = (params: UseUpdatePolicyTemplateFavoriteParams) => {
    const { updatePolicyTemplate, loading, error } = useUpdatePolicyTemplate(params);

    const updatePolicyTemplateFavorite = useCallback(
        async (templateId: PolicyTemplate['id'], isFavorite: boolean) => {
            await updatePolicyTemplate(templateId, { isFavorite });
        },
        [updatePolicyTemplate]
    );

    return {
        loading,
        error,
        updatePolicyTemplateFavorite
    };
};
